import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { ContentSpacing, Breakpoints } from '@estee/elc-base-theme';

export interface IDefaultColumn {
    columns: number;
    rows: number;
}

export interface IColumnRenderer {
    isMobile: boolean;
    children?: JSX.Element;
    isCarousel?: boolean;
    columns?: number;
    rows?: number;
    className?: string;
}

const DefaultColumn = styled.div<IDefaultColumn>`
    padding: ${ContentSpacing.space8};
    grid-column-end: span 1;
    grid-row-end: span 1;
    width: 100%;
    @media (min-width: ${Breakpoints.desktop}px) {
        grid-column-end: span ${({ columns }) => columns};
        grid-row-end: span ${({ rows }) => rows};
        width: auto;
        ${(props) => (props.columns === 0 ? 'grid-column: 1 / -1;' : '')}
    }
    &:hover {
        z-index: 1;
    }
`;

const CarouselColumn = styled.div<IDefaultColumn>`
    padding: ${ContentSpacing.space8};
`;

export const ColumnRenderer = observer(function ColumnRenderer(props: IColumnRenderer) {
    const { isCarousel = false, columns = 1, rows = 1 } = props;
    const ColumnWrapper = isCarousel ? CarouselColumn : DefaultColumn;

    return (
        <ColumnWrapper columns={columns} rows={rows} className={props.className}>
            {props.children}
        </ColumnWrapper>
    );
});
